// Frame of every public page: skip link, header, main landmark, footer, and
// the document title and description for the route.

import { type ReactNode, useEffect } from 'react';
import { SiteFooter, SiteHeader } from './chrome';
import './site.css';

const DEFAULT_TITLE = 'ZeroQube';
const DEFAULT_DESCRIPTION = 'Quantum-resistant spending authority for your Solana assets. Hold and swap from the same vault. Experimental; external audit pending.';

export function useDocumentMeta(title: string, description = DEFAULT_DESCRIPTION): void {
  useEffect(() => {
    const previousTitle = document.title;
    const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const previousDescription = meta?.content;
    document.title = title;
    if (meta) meta.content = description;
    return () => {
      document.title = previousTitle || DEFAULT_TITLE;
      if (meta && previousDescription !== undefined) meta.content = previousDescription;
    };
  }, [title, description]);
}

export function SitePage({
  launchHref,
  children,
  className = '',
  title = 'ZeroQube · Quantum-resistant. Built to be used.',
  description,
}: {
  launchHref: string;
  children: ReactNode;
  className?: string;
  title?: string;
  description?: string;
}) {
  useDocumentMeta(title, description);
  return (
    <div className={`site ${className}`.trim()}>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <SiteHeader launchHref={launchHref} />
      <main id="main" tabIndex={-1}>
        {children}
      </main>
      <SiteFooter launchHref={launchHref} />
    </div>
  );
}
